export default __webpack_public_path__ + "static/media/corded-image-example.f9d3e66b.webp";